import gql from 'graphql-tag'
import {
	category as categoryFragment,
	surcharge as surchargeFragment,
	options as optionsFragment
} from './fragments'


export default gql`
mutation updateManyCategories($idArr: [ID]!, $fields: CategoryFields!) {
	cashAssist {
		updateManyCategories(idArr: $idArr, fields: $fields) {
			id
			mod_ver
			cashRegisterId
			concepts
			...categorymain
			...categorySurcharge
			...categoryOptions
		}
	}
}
${categoryFragment}
${surchargeFragment}
${optionsFragment}`

